//dependencias
import React, { Component } from 'react';

//componentes
import MedicamentoAction from './Medicamento'

class Medicamento extends Component {

    render(){
        return(
            <div>
                <MedicamentoAction />
            </div>
        );
    }

}
export default Medicamento;